import {
  Server, Boxes, Network, Cloud, Code2, Workflow, BarChart3,
  DatabaseBackup, Rocket, Activity, LockKeyhole, ScanFace,
  ClipboardCheck, LifeBuoy,
} from "lucide-react";

export const BRAND = {
  name: "DMO Technology",
  short: "DMO",
  tagline: "IT Infrastructure & Software Engineering",
  website: "dmo-tech.ro",
  email: "daniel@dmo-tech.ro",
  phone: "0725 626 426",
  whatsapp: "40725626426", // format international fara + pentru wa.me
  city: "Piatra Neamț",
  county: "jud. Neamț",
  region: "Piatra Neamț, jud. Neamț",
};

// Google Maps embed (fara API key) centrat pe Piatra Neamt, jud. Neamt
export const MAPS_EMBED_URL =
  "https://www.google.com/maps?q=Piatra%20Neamt%2C%20jud.%20Neamt%2C%20Romania&z=13&output=embed";
export const MAPS_LINK_URL =
  "https://www.google.com/maps/place/Piatra+Neamt,+Neamt+County,+Romania";

export const WHATSAPP_URL = `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(
  "Salut! Am gasit site-ul DMO Technology si as vrea sa discutam despre un proiect IT."
)}`;
export const MAILTO_URL = `mailto:${BRAND.email}?subject=${encodeURIComponent(
  "Cerere colaborare — DMO Technology"
)}`;

export const SERVICES = [
  {
    id: "01", icon: Server, feature: true,
    title: "Administrare infrastructură IT",
    title_en: "IT infrastructure administration",
    desc: "Servere Windows și Linux, storage, backup, monitorizare, mentenanță și troubleshooting non-stop.",
    desc_en: "Windows and Linux servers, storage, backup, monitoring, maintenance and round-the-clock troubleshooting.",
    tags: ["Windows Server", "Linux", "Storage", "Mentenanță"],
  },
  {
    id: "02", icon: Boxes, feature: true,
    title: "Virtualizare pe serverul tău",
    title_en: "Virtualization on your server",
    desc: "Nu vindem virtualizare la pachet — o construim pe fierul tău, dimensionată pe resursele tale: Proxmox, VM-uri, LXC, ZFS, clustere și migrare fără downtime.",
    desc_en: "We don't sell packaged virtualization — we build it on your own hardware, sized to your resources: Proxmox, VMs, LXC, ZFS, clusters and zero-downtime migration.",
    tags: ["Proxmox", "ZFS", "Cluster", "On-premise"],
  },
  {
    id: "03", icon: Network,
    title: "Rețele & securitate",
    title_en: "Networking & security",
    desc: "pfSense, MikroTik, OpenWrt, VLAN, VPN, firewall, multi-WAN, failover, routing și segmentare.",
    desc_en: "pfSense, MikroTik, OpenWrt, VLAN, VPN, firewall, multi-WAN, failover, routing and segmentation.",
    tags: ["pfSense", "MikroTik", "VLAN", "Multi-WAN"],
  },
  {
    id: "04", icon: Cloud,
    title: "Cloud privat, pe infrastructura ta",
    title_en: "Private cloud, on your infrastructure",
    desc: "Nextcloud, Docker, Coolify, aplicații self-hosted și cloud privat care rămâne fizic la tine — datele tale, pe serverul tău, nu la un furnizor extern.",
    desc_en: "Nextcloud, Docker, Coolify, self-hosted apps and a private cloud that stays physically with you — your data, on your server, not with an external provider.",
    tags: ["Nextcloud", "Docker", "Self-hosted", "Private"],
  },
  {
    id: "05", icon: Code2,
    title: "Dezvoltare software",
    title_en: "Software development",
    desc: "Aplicații web, portaluri, CRM/ERP, PWA, baze de date și aplicații business personalizate.",
    desc_en: "Web apps, portals, CRM/ERP, PWA, databases and custom business applications.",
    tags: ["Web Apps", "CRM/ERP", "PWA", "API"],
  },
  {
    id: "06", icon: Workflow,
    title: "Automatizări & integrări",
    title_en: "Automation & integrations",
    desc: "Automatizarea proceselor, integrarea aplicațiilor, API-uri, sincronizări de date și workflow-uri.",
    desc_en: "Process automation, application integration, APIs, data syncing and workflows.",
    tags: ["API", "Workflow", "Sync", "Integrare"],
  },
  {
    id: "07", icon: BarChart3,
    title: "ERP & raportare",
    title_en: "ERP & reporting",
    desc: "Configurări și dezvoltări ERP, rapoarte, Generic Inquiries, Business Events și integrare cu alte sisteme.",
    desc_en: "ERP configuration and development, reports, Generic Inquiries, Business Events and integration with other systems.",
    tags: ["ERP", "GI", "Rapoarte", "Events"],
  },
  {
    id: "08", icon: DatabaseBackup,
    title: "Backup & Disaster Recovery",
    title_en: "Backup & Disaster Recovery",
    desc: "Strategii de backup, Proxmox Backup Server, Macrium, baze de date, restore și replicare.",
    desc_en: "Backup strategies, Proxmox Backup Server, Macrium, databases, restore and replication.",
    tags: ["PBS", "Macrium", "Restore", "Replicare"],
  },
  {
    id: "09", icon: Rocket,
    title: "Publicare aplicații pe infrastructura ta",
    title_en: "App deployment on your infrastructure",
    desc: "Docker, Coolify, GitHub deployment, HAProxy, Cloudflare, SSL și reverse proxy — publicate pe serverul tău, sub controlul tău, fără dependență de un hosting extern.",
    desc_en: "Docker, Coolify, GitHub deployment, HAProxy, Cloudflare, SSL and reverse proxy — deployed on your own server, under your control, without depending on external hosting.",
    tags: ["Docker", "HAProxy", "SSL", "On-premise"],
  },
  {
    id: "10", icon: Activity,
    title: "Monitorizare IT",
    title_en: "IT monitoring",
    desc: "Zabbix, monitorizare servere, rețele, servicii, uptime și alerte în timp real.",
    desc_en: "Zabbix, monitoring of servers, networks, services, uptime and real-time alerts.",
    tags: ["Zabbix", "Uptime", "Alerte", "Metrics"],
  },
  {
    id: "11", icon: LockKeyhole,
    title: "Securitate & acces remote",
    title_en: "Security & remote access",
    desc: "VPN, firewall, acces securizat între sedii, Cloudflare, HAProxy și politici de acces.",
    desc_en: "VPN, firewall, secure inter-site access, Cloudflare, HAProxy and access policies.",
    tags: ["VPN", "Firewall", "Zero-Trust", "SSO"],
  },
  {
    id: "12", icon: ScanFace,
    title: "Control acces & echipamente",
    title_en: "Access control & devices",
    desc: "Dahua, gateway-uri, utilizatori, evenimente, anti-passback și management centralizat.",
    desc_en: "Dahua, gateways, users, events, anti-passback and centralized management.",
    tags: ["Dahua", "Gateway", "Anti-passback"],
  },
  {
    id: "13", icon: ClipboardCheck,
    title: "Consultanță IT & audit",
    title_en: "IT consulting & audit",
    desc: "Analiza infrastructurii și a proceselor, recomandări, arhitectură și planuri de optimizare.",
    desc_en: "Infrastructure and process analysis, recommendations, architecture and optimization plans.",
    tags: ["Audit", "Arhitectură", "Optimizare"],
  },
  {
    id: "14", icon: LifeBuoy,
    title: "Suport & administrare recurentă",
    title_en: "Support & recurring administration",
    desc: "Asistență remote, mentenanță, update-uri, backup, suport utilizatori și administrare completă.",
    desc_en: "Remote assistance, maintenance, updates, backup, user support and full administration.",
    tags: ["Remote", "SLA", "Mentenanță", "24/7"],
  },
];

export const STATS = [
  { value: "14+", label: "Servicii integrate" },
  { value: "24/7", label: "Monitorizare & suport" },
  { value: "20+", label: "Ani de experiență" },
  { value: "99.9%", label: "Uptime țintă" },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Gândit ca un sistem, nu ca un patch.",
    body: "Fiecare proiect pornește de la arhitectură. Rețele segmentate, redundanță reală și documentație clară — infrastructură pe care te poți baza ani de zile, nu doar până la următoarea pană.",
  },
  {
    no: "02",
    title: "Securitate din prima linie de cod.",
    body: "Firewall, VPN, zero-trust, backup testat și disaster recovery. Securitatea nu e un add-on la final, e fundația pe care construim tot restul.",
  },
  {
    no: "03",
    title: "Automatizăm tot ce se repetă.",
    body: "De la deployment cu Docker & Coolify până la sincronizări prin API și workflow-uri ERP. Mai puțină muncă manuală, mai puține erori, mai mult timp pentru afacerea ta.",
  },
];

export const PROJECTS = [
  {
    title: "Private Cloud & Virtualizare",
    title_en: "Private Cloud & Virtualization",
    cat: "Proxmox · ZFS · Backup",
    desc: "Cluster Proxmox cu storage ZFS, backup automat pe Proxmox Backup Server și migrare live între noduri.",
    desc_en: "Proxmox cluster with ZFS storage, automated backup on Proxmox Backup Server and live migration between nodes.",
    img: "https://images.pexels.com/photos/37730211/pexels-photo-37730211.jpeg",
    span: "lg:col-span-7",
  },
  {
    title: "Securitate multi-sediu",
    title_en: "Multi-site security",
    cat: "pfSense · VPN · Multi-WAN",
    desc: "Interconectare securizată între sedii cu failover și segmentare VLAN.",
    desc_en: "Secure interconnection between sites with failover and VLAN segmentation.",
    img: "https://images.unsplash.com/photo-1562575214-da9fcf59b907",
    span: "lg:col-span-5",
  },
  {
    title: "Platformă ERP & raportare",
    title_en: "ERP platform & reporting",
    cat: "ERP · Business Events",
    desc: "Generic Inquiries, rapoarte custom și integrări cu sisteme externe.",
    desc_en: "Generic Inquiries, custom reports and integrations with external systems.",
    img: "https://images.pexels.com/photos/27141316/pexels-photo-27141316.jpeg",
    span: "lg:col-span-5",
  },
  {
    title: "Deployment & Monitorizare",
    title_en: "Deployment & Monitoring",
    cat: "Docker · Zabbix · Cloudflare",
    desc: "Pipeline de publicare cu HAProxy, SSL, reverse proxy și alerting Zabbix în timp real.",
    desc_en: "Deployment pipeline with HAProxy, SSL, reverse proxy and real-time Zabbix alerting.",
    img: "https://images.pexels.com/photos/17489163/pexels-photo-17489163.jpeg",
    span: "lg:col-span-7",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Au preluat o infrastructură haotică și au transformat-o într-un sistem stabil, documentat și monitorizat. De atunci dormim liniștiți.",
    quote_en:
      "They took over a chaotic infrastructure and turned it into a stable, documented and monitored system. We've slept soundly ever since.",
    name: "Andrei M.",
    role: "IT Manager · Producție",
    role_en: "IT Manager · Manufacturing",
  },
  {
    quote:
      "Migrarea pe Proxmox și backup-ul automat ne-au salvat literalmente afacerea la o pană de hardware. Restore în minute, zero pierderi.",
    quote_en:
      "The Proxmox migration and automated backups literally saved our business during a hardware failure. Restore in minutes, zero data loss.",
    name: "Cristina P.",
    role: "Administrator · Retail",
    role_en: "Administrator · Retail",
  },
  {
    quote:
      "Rapizi, tehnici și onești. Ne-au livrat integrarea ERP și automatizările exact cum am cerut, cu suport constant după implementare.",
    quote_en:
      "Fast, technical and honest. They delivered the ERP integration and automations exactly as requested, with constant post-implementation support.",
    name: "Vlad D.",
    role: "CEO · Distribuție",
    role_en: "CEO · Distribution",
  },
];

export const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/c74574e6-69b0-4d56-80d7-aa66fb56a651/images/0cc09a0e03b44787ede8e8ca9400d36855f94e9ccc112abbd504a0d1ff072acb.jpeg";
